const PHOTO_CAPTURE_URL = '/virtual/smart-skin-scan/photo-capture';
const SKIN_ANALYSIS_TOOL = 'skin-analysis-tool';

export {
    PHOTO_CAPTURE_URL, SKIN_ANALYSIS_TOOL
};
